module.exports = __webpack_public_path__ + "img/组 494@2x.536a6bf3.png";